import { TblPagination } from '../table.types';
import { buildPageBatches } from './buildPageBatches';

type GetPaginationLogicReturn = {
    pagesByBatch: number[][];
    batchIndex: number;
    pageNumbersVisible: number[];
    showNavToFirst: boolean;
    showNavToLast: boolean;
    showNavToPrevBatch: boolean;
    showNavToNextBatch: boolean;
};

export function getPaginationLogic(paging: TblPagination, pageBatchSize: number): GetPaginationLogicReturn {
    const pagesByBatch = buildPageBatches(paging.total, pageBatchSize);
    const batchIndex = Math.floor((paging.page - 1) / pageBatchSize);
    const pageNumbersVisible = pagesByBatch[batchIndex] ?? [];
    const totalBatches = Math.ceil(paging.total / pageBatchSize);
    const showNavToFirst = totalBatches > 2 && batchIndex > 1;
    const showNavToLast = totalBatches > 2 && batchIndex < totalBatches - 2;
    const showNavToPrevBatch = totalBatches > 1 && batchIndex > 0;
    const showNavToNextBatch = totalBatches > 1 && batchIndex < totalBatches - 1;

    return {
        pagesByBatch,
        batchIndex,
        pageNumbersVisible,
        showNavToFirst,
        showNavToLast,
        showNavToPrevBatch,
        showNavToNextBatch,
    };
}
